(function () {
    'use strict';

    /*
    Examples:
        - step 1: inject service 'npDialog'
        - step 2: 
            npDialog.showDialog(
            {
                type: dialogTypes.OK,
                message: resources.M.Document.confirmDeleteDocumentTemplates,
                title: resources.L.Action.deleteDocumentType
            });
    */
    angular.module('servicesModule').service('npDialog', npDialog);
    npDialog.$inject = ['$uibModal'];

    function npDialog($uibModal) {
        var service = {
            showDialog: showDialog
        };

        return service;

        function showDialog(dialogInfo, dialogCloseCallback) {
            var modalInstance = $uibModal.open({
                templateUrl: '/app/shared/dialogs/npDialog.html',
                controller: 'DialogController as vm',
                size: 'lg',
                backdrop: (dialogInfo.backdrop == null) ? true : dialogInfo.backdrop,
                resolve: {
                    dialogInfo: function () {
                        return dialogInfo;
                    }
                }
            });

            modalInstance.result.then(function (data) {
                dialogCloseCallback(data);
            });
        }
    };

    angular.module('servicesModule')
           .controller('DialogController', dialogController);

    dialogController.$inject = ['$scope', '$uibModalInstance', '$sce', 'dialogInfo'];
    function dialogController($scope, $modalInstance, $sce, dialogInfo) {
        var vm = this;
        $scope.translation = globalResources;
        $scope.dialogInfo = dialogInfo;
        $scope.confirm = confirm;
        $scope.cancel = cancel;

        $scope.dialogInfo.message = $sce.trustAsHtml($scope.dialogInfo.message);

        vm.enableButton = false;
        vm.hearingEmailNotification = HandbookConfiguration.HearingDocApprovedNotification.toUpperCase() == "TRUE";
        var html = '<div class="table-css">';
        html += "    <div class='table-row'><span class='tooltip-hearing'><b>" + $scope.translation.HearingEmailNotificationTooltip;
        html += "</b></span></div>";
        html += '</div>';
        vm.hearingEmailNotificationTooltip = $sce.trustAsHtml(html);

        $scope.initialize = function () {
            vm.donotShowAgain = false;
            vm.shouldApplyRecursive = true;
            if ($scope.dialogInfo.title == '' || $scope.dialogInfo.title == null) {
                switch ($scope.dialogInfo.type) {
                    case dialogTypes.OK:
                        $scope.dialogInfo.title = $scope.translation.InformDialogTitle;
                        break;
                    case dialogTypes.OK_CANCEL:
                    case dialogTypes.YES_NO:
                        $scope.dialogInfo.title = $scope.translation.ConfirmDialogTitle;
                        break;
                    default:
                        $scope.dialogInfo.title = $scope.translation.InformDialogTitle;
                        break;
                }
            }
            if ($scope.dialogInfo.enableButton != null) {
                vm.enableButton = $scope.dialogInfo.enableButton;
            }
        }

        function confirm($event) {
            if ($scope.dialogInfo.toggleDonotShowAgain) {
                $modalInstance.close({ result: dialogResults.CONFIRM, donotShowAgain: vm.donotShowAgain });
            } else if ($scope.dialogInfo.toggleApplyRecursive) {
                $modalInstance.close({ result: dialogResults.CONFIRM, shouldApplyRecursive: vm.shouldApplyRecursive });
            } if ($scope.dialogInfo.toggleReason) {
                $modalInstance.close({ result: dialogResults.CONFIRM, reason: vm.reason, emailNotification: vm.hearingEmailNotification });
            } else {
                $modalInstance.close(dialogResults.CONFIRM);
            }
        }

        function cancel($event) {
            if ($scope.dialogInfo.toggleDonotShowAgain) {
                $modalInstance.close({ result: dialogResults.CANCEL, donotShowAgain: vm.donotShowAgain });
            } else if ($scope.dialogInfo.toggleApplyRecursive) {
                $modalInstance.close({ result: dialogResults.CANCEL, shouldApplyRecursive: vm.shouldApplyRecursive });
            } if ($scope.dialogInfo.toggleReason) {
                $modalInstance.close({ result: dialogResults.CANCEL, reason: vm.reason });
            } else {
                $modalInstance.close(dialogResults.CANCEL);
            }
        }
    };
})();

